import {
  NgModule,
} from '@angular/core';

import {
  CommonModule,
} from '@angular/common';

import {
  FormsModule,
} from '@angular/forms';

import {
  FlexLayoutModule,
} from '@angular/flex-layout';

import {
  MatButtonModule,
} from '@angular/material/button';

import {
  MatIconModule,
} from '@angular/material/icon';

import {
  FilterComponent,
} from './containers/filter/filter.component';


export const MATERIAL_MODULES = [
  MatButtonModule,
  MatIconModule,
];


@NgModule({

  declarations: [
    FilterComponent,
  ],

  imports: [
    ...MATERIAL_MODULES,
    CommonModule,
    FormsModule,
    FlexLayoutModule,
  ],

  exports: [
    FilterComponent,
  ],

})
export class ThemeComponentsFilterModule { }

